import { render, staticRenderFns } from "./CallLogDetail.vue?vue&type=template&id=1422e080&"
import script from "./CallLogDetail.vue?vue&type=script&lang=js&"
export * from "./CallLogDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports